(ns ncr.reports.revenue
  (:require
   [clojure.string :as str]
   [clojure.core.match :refer-macros [match]]
   [cljs.core.async :as async :refer-macros [go]]
   [goog.events.KeyCodes :as KeyCodes]
   [uix.core.alpha :as uix]
   [ncr.etc.pf :as pf]
   [ncr.etc.pubsub :as ps]
   [ncr.etc.rhf :as rhf]
   [ncr.etc.util :as u]
   [ncr.etc.modal :as m]
   [ncr.widgets.core :as w]
   [ncr.widgets.input :as wi]
   [ncr.widgets.grid :as grid]
   [ncr.reports.grid-cell :as gc]
   [ncr.reports.details]
   [ncr.reports.explain]
   [ncr.reports.common :as rc]))

(def ^:private glob-autocomplete-options
  ["income/*"])

(defn- glob-form [{:keys [control] :as form} submit]
  (let [input-ref (uix/ref)]
    (uix/with-effect [@input-ref]
      #(when-let [el @input-ref]
         (.focus el)))

    [rhf/c-controller
     {:name :value
      :control control

      :rules
      {:required true
       :validate
       {:not-blank
        (fn [v]
          (or
            (not (str/blank? v))
            "can't be blank"))}}

      :render
      (fn [{{:keys [on-change value]} :field}]
        [pf/c-form {:on-submit #(.preventDefault %)}
         (let [id (uix/memo #(gensym) [])]
           [rhf/c-form-group
            {:label "Subsection filter" :is-required true :field-id id}
            :value
            form
            [wi/c-autocomplete
             {:id id
              :ref input-ref
              :options (clj->js glob-autocomplete-options)
              :on-change on-change
              :on-key-down #(when (= KeyCodes/ENTER (u/key-code %)) (submit %))
              :value value}]])])}]))

(defn- glob-dialog-body [action]
  (let
    [modal-id :report-glob-modal
     modal-ref (uix/ref)

     action-s
     (match action
       [:edit _] "Edit"
       :add "Add")

     form
     (rhf/use-form
       {:shouldFocusError false
        :default-values
        {:value
         (match action
           [:edit value]
           value
           _
           "")}})

     submit (rhf/modal-submit form)]

    (m/use-submit-form modal-id modal-ref submit)

    [m/c-modal
     {:title (str action-s " subsection")
      :variant :small
      :is-overflow-visible true
      :id modal-id
      :ref modal-ref
      :actions
      [[pf/c-button
        {:variant :primary
         :on-click submit}
        action-s]

       [pf/c-button
        {:variant :link
         :on-click #(m/close! nil)}
        "Cancel"]]}
     [glob-form form submit]]))

(defn- c-glob-heading [{:keys [label glob rdef-path can-manage?]}]
  [:span.ncr-grid-heading
   label
   (when can-manage?
     [grid/tools
      [:pencil
       (u/isolate*
         #(go
            (when-let [{:keys [value]} (async/<! (m/!modal #'glob-dialog-body [:edit glob]))]
              (ps/pub! [:ncr.reports.core/edit rdef-path [:replace glob value]]))))]
      [:delete
       (u/isolate*
         #(go
            (when
              (async/<!
                (m/!alert
                  {:title "Remove subsection"
                   :actions-variant :ok-cancel
                   :body [:span "Are you sure, you want to remove the subsection?"]}))
              (ps/pub! [:ncr.reports.core/edit rdef-path [:delete glob]]))))]])])

(defn- data-row [report paths id props]
  (gc/data-row report (assoc paths :cube-path [id])
    props
    {:extension ncr.reports.explain/c-explain-plain
     :filter-zeroes? true}))

(defn- render [paths {:keys [labels me] :as report} {:keys [heading]}]
  (let
    [rdef-path (get paths :report-path)
     cube (rc/from-path report paths)
     values (get-in cube [:axes 0 :values])
     can-manage? (-> me :roles (contains? :administrator))]
    (concat
      [{:type :header
        :heading [:span.ncr-grid-heading heading]}]
      (apply concat
        (let [heading-args {:rdef-path rdef-path :can-manage? can-manage?}]
          (for [[glob lids] (sort-by key values)]
            (let [heading-args (assoc heading-args :glob glob :label glob)]
              (if (= 1 (count lids))
                (let [[lid] lids]
                  [(data-row report paths lid {:heading (c-glob-heading (assoc heading-args :label (labels lid)))})])
                [(assoc
                   (data-row report paths glob {:heading (c-glob-heading heading-args)})
                   :sub-rows
                   (for [[lid lname] (sort-by val (select-keys labels lids))]
                     (data-row report paths lid {:heading lname})))])))))
      [(data-row report paths :other
         {:heading
          [:span.ncr-grid-heading
           "Other"
           (when can-manage?
             [grid/tools
              [:plus
               (u/isolate*
                 #(go
                    (when-let [{:keys [value]} (async/<! (m/!modal #'glob-dialog-body :add))]
                      (ps/pub! [:ncr.reports.core/edit rdef-path [:add value]]))))]])]})
       (data-row report paths :total {:heading "Total"})])))

(def render-income
  (partial render {:report-path [:cashflow :revenue] :sym-path [:income] :uniq :revenue}))

(def render-expense
  (partial render {:report-path [:cashflow :costs] :sym-path [:expense] :uniq :revenue}))
